var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.tipShow
        ? _c(
            "el-tooltip",
            {
              staticClass: "item",
              attrs: {
                effect: "dark",
                content: _vm.placeholder,
                placement: "top",
              },
            },
            [
              _c("el-date-picker", {
                staticClass: "full-width",
                attrs: {
                  type: "date",
                  readonly: _vm.readonly,
                  disabled: _vm.disabled,
                  "value-format": _vm.valueFormat,
                  "picker-options": _vm.pickerOptions,
                  format: _vm.format,
                  placeholder: _vm.placeholder || _vm.$t("chooseText"),
                  size: _vm.size,
                },
                model: {
                  value: _vm.id,
                  callback: function ($$v) {
                    _vm.id = $$v
                  },
                  expression: "id",
                },
              }),
            ],
            1
          )
        : _c("el-date-picker", {
            staticClass: "full-width",
            attrs: {
              type: "date",
              readonly: _vm.readonly,
              disabled: _vm.disabled,
              "value-format": _vm.valueFormat,
              "picker-options": _vm.pickerOptions,
              format: _vm.format,
              placeholder: _vm.placeholder || _vm.$t("chooseText"),
              size: _vm.size,
            },
            model: {
              value: _vm.id,
              callback: function ($$v) {
                _vm.id = $$v
              },
              expression: "id",
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }